export const HeaderTools: {
  label: string;
  tools: {
    title: string;
    describe: string;
    url?: string;
    icon: string;
    isDialog?: boolean;
    dialogType?: string;
    category?: '计划' | '单元' | '创意' | '关键词';
  }[];
}[] = [
  {
    label: '批量工具',
    tools: [
      {
        title: '批量创建计划',
        describe: '聚光创编链路升级版，可快速创建百条计划',
        url: '/create-campaign-v2',
        icon: 'assets/images/tools/create-campaign.png',
      },
      {
        title: '批量创建单元',
        describe: '叉乘逻辑，可快速创建百条单元',
        url: '/create-unit',
        icon: 'assets/images/tools/create-unit.png',
      },
      {
        title: '定制化创建计划',
        describe: '自定义搭建，可快速创建百条计划',
        url: '/create-campaign-pro',
        icon: 'assets/images/tools/custom-campaign.png',
      },
      {
        title: '批量添加创意',
        describe: '批量添加创意，可快速创建百条创意',
        url: '/promotion/unify?index=5',
        icon: 'assets/images/tools/create-creative.png',
      },
    ],
  },
  {
    label: '表格工具',
    tools: [
      {
        title: '批量上传计划',
        describe: '表格导入计划信息，高效完成计划搭建',
        icon: 'assets/images/tools/upload-campaign.png',
        isDialog: true,
        dialogType: 'campaignUpload',
        category: '计划',
      },
      {
        title: '批量修改计划预算',
        describe: '表格批量修改计划预算，统一调整更快捷',
        icon: 'assets/images/tools/campaign-budget.png',
        isDialog: true,
        dialogType: 'campaignBudget',
        category: '计划',
      },
      {
        title: '批量修改计划名称',
        describe: '表格批量修改计划名称，统一调整更快捷',
        icon: 'assets/images/tools/campaign-name.png',
        isDialog: true,
        dialogType: 'campaignName',
        category: '计划',
      },
      {
        title: '批量修改计划状态',
        describe: '表格批量修改计划状态，统一调整更快捷',
        icon: 'assets/images/tools/campaign-status.png',
        isDialog: true,
        dialogType: 'campaignStatus',
        category: '计划',
      },
      {
        title: '批量修改单元出价',
        describe: '表格批量修改单元出价，统一调整更快捷',
        icon: 'assets/images/tools/unit-bid.png',
        isDialog: true,
        dialogType: 'unitBid',
        category: '单元',
      },
      {
        title: '批量修改单元名称',
        describe: '表格批量修改单元名称，统一调整更快捷',
        icon: 'assets/images/tools/unit-name.png',
        isDialog: true,
        dialogType: 'unitName',
        category: '单元',
      },
      {
        title: '批量修改单元高级定向',
        describe: '表格批量修改单元高级定向，统一调整更快捷',
        icon: 'assets/images/tools/unit-target.png',
        isDialog: true,
        dialogType: 'unitTarget',
        category: '单元',
      },
      {
        title: '批量修改单元状态',
        describe: '表格批量修改单元状态，统一调整更快捷',
        icon: 'assets/images/tools/unit-status.png',
        isDialog: true,
        dialogType: 'unitStatus',
        category: '单元',
      },
      {
        title: '批量添加创意',
        describe: '表格导入多平台创意，高效完成发布',
        icon: 'assets/images/tools/upload-creative.png',
        isDialog: true,
        dialogType: 'creativeUpload',
        category: '创意',
      },
      {
        title: '批量编辑创意',
        describe: '表格批量修改创意内容，统一调整更快捷',
        icon: 'assets/images/tools/edit-creative.png',
        isDialog: true,
        dialogType: 'creativeEdit',
        category: '创意',
      },
      {
        title: '批量上传创意监测链接',
        describe: '表格导入跟踪链接，快速配置监测',
        icon: 'assets/images/tools/creative-monitor.png',
        isDialog: true,
        dialogType: 'monitor',
        category: '创意',
      },
      {
        title: '批量修改创意状态',
        describe: '表格批量修改创意状态，统一调整更快捷',
        icon: 'assets/images/tools/creative-status.png',
        isDialog: true,
        dialogType: 'creativeStatus',
        category: '创意',
      },
      {
        title: '批量上传关键词',
        describe: '表格批量添加账户关键词，省时省力',
        icon: 'assets/images/tools/upload-keyword.png',
        isDialog: true,
        dialogType: 'keyword',
        category: '关键词',
      },
      {
        title: '批量修改关键词出价',
        describe: '表格批量修改关键词出价，统一调整更快捷',
        icon: 'assets/images/tools/keyword-bid.png',
        isDialog: true,
        dialogType: 'keywordBid',
        category: '关键词',
      },
      {
        title: '批量修改关键词匹配模式',
        describe: '表格批量修改关键词匹配模式，统一调整更快捷',
        icon: 'assets/images/tools/keyword-match.png',
        isDialog: true,
        dialogType: 'keywordMatchType',
        category: '关键词',
      },
    ],
  },
  {
    label: '其他工具',
    tools: [
      {
        title: '任务管理',
        describe: '实时监控批量创建任务执行状态',
        url: '/task-list',
        icon: 'assets/images/tools/task-manager.png',
      },
      // {
      //   title: '商品关键词关联',
      //   describe: '商品关键词关联，商品关键词自由掌控',
      //   url: '/tools/marking',
      //   icon: 'assets/images/tools_marking.png',
      // },
      {
        title: '操作记录',
        describe: '操作记录，每一步操作都有留痕',
        url: '/tools/operation-record',
        icon: 'assets/images/tools/operation-log.png',
      },
      {
        title: '笔记ID解析',
        describe: '解析笔记ID，高效提取省时省力',
        url: '/tools/note-id-parsing',
        icon: 'assets/images/tools/note-id.png',
      },
      {
        title: '笔记预审',
        describe: '自定义笔记审核，笔记预审自由掌控',
        url: '/tools/note-audit',
        icon: 'assets/images/tools/note-review.png',
      },
      // {
      //   title: '定向包',
      //   describe: '定向包管理，人群管理自由掌控',
      //   url: '/tools/target-package',
      //
      // }
    ],
  },
];

export const GroupedHeaderTools = HeaderTools.map((section) => ({
  ...section,
  groups: section.tools.some((tool) => tool.category)
    ? (['计划', '单元', '创意', '关键词'] as const).map((category) => ({
        label: category,
        tools: section.tools.filter((tool) => tool.category === category),
      }))
    : [{ label: '', tools: section.tools }],
}));
